import styled from '../../theme/theme';
import { Box } from '../OPL/Box/Box';

interface PageWrapperProps {
  isEmbeddedMobile?: boolean;
}

export const PageWrapper = styled(Box)<PageWrapperProps>(({ isEmbeddedMobile = false }) => ({
  minWidth: isEmbeddedMobile ? 0 : 1000,
  margin: '0 -30px',
  padding: '0 30px',
}));
